module.exports = __webpack_public_path__ + "img/mini-admin.a592f922.svg";